import React, { useState } from 'react';
import { Button } from '@mui/material';
import useStyles from './styles.js';
import LogsApiView from './LogsApiView.js';
import { useParams } from 'react-router-dom';

const ApisDataSync = () => {

  const { service } = useParams();
  const classes = useStyles();
  const [filter, setFilter] = useState();

  return (
    <div className={classes.container}>
      <div className={classes.buttonContainer}>
        <Button variant="contained" color="primary" onClick={() => setFilter('IN')}>
          Données reçues
        </Button>
        <Button variant="contained" color="primary" onClick={() => setFilter('OUT')}>
          Données envoyées
        </Button>
      </div>
      {service && filter && <LogsApiView service={service} type={filter} />}
    </div>
  );
};

export default ApisDataSync;